import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { allBooks, deleteBook } from "../modules/books";
import { Article } from "./Article";

const BookList = () => {
  const dispatch = useDispatch();
  const { books } = useSelector((state) => state);

  useEffect(() => {
    dispatch(allBooks());
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div>
      <div className="col-sm-12">
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        {/* <h1 style={{color:"#bdc3c7"}}>Danh sách ứng dụng</h1> */}
        <table
          className="table table-striped"
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            zIndex: 100,
            paddingRight: 40,
          }}
        >
          <tbody>
            <tr style={{ backgroundColor: "transparent" }}>
              <td>
                <Article
                  category={"MDM"}
                  color={"00b900"}
                  title={"Master Data Management"}
                  details={"Quản lý dữ liệu dùng chung"}
                  link={"https://fcim.mkvision.com/mdm"}
                />
              </td>
              <td>
                <Article
                  category={"APS"}
                  color={"FE5621"}
                  title={"APS"}
                  details={"Phần mềm Quản ký kế hoạch sản xuất"}
                  link={"https://fcim.mkvision.com/aps"}
                />
              </td>
              {/*<td><Article category = {"Document"} color={"00b894"} title={"Document"}*/}
              {/*            details={"Kho tài liệu"}*/}
              {/*            link={"http://192.168.68.88/"}/></td>*/}

              {/*  <td><Article category = {"Forums"} color={"993AB7"} title={"Rang Dong's Forums"}*/}
              {/*           details={"Rạng Đông Forums"}*/}
              {/*link={"http://192.168.68.87:8800/public"} /></td>*/}
              {/*<td><Article category = {"Warning"} color={"112AB5"} title={"Warning"}*/}
              {/*           details={"Hệ thống cảnh báo"}*/}
              {/*           link={"http://192.168.68.87:9080/"}/></td>*/}
              <td>
                <Article
                  category={"WMS"}
                  color={"101AC1"}
                  title={"WMS"}
                  details={"Phần mềm quản lý kho"}
                  link={"https://fcim.mkvision.com/wms"}
                />
              </td>
              <td>
                <Article
                  category={"QMS"}
                  color={"2196F3"}
                  title={"QMS"}
                  details={"Phần mềm Kiểm soát chất lượng"}
                  link={"https://fcim.mkvision.com/qms"}
                />
              </td>
              {/* <td><Article category = {"SCADA"} color={"FEC006"} title={"SCADA"}
                          details={"Nền tảng IOT Platform"}
                          link={"http://52.220.77.124:4200/"}/></td>
             <td><Article category = {"MRP"} color={"CBB279"} title={"MRP"}
                          details={"Quản lý kế hoạch nguyên vật liệu"}
                          link={"http://192.168.68.96:4200"}/></td> */}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BookList;
